
/* ============================== src/components/Icons.jsx ============================== */
// src/components/Icons.jsx
export const Ic = ({ d, size = 18, w = 1.8 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={w}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={d} />
  </svg>
);
